(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 52036:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(11066);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/Input.module.scss
var Input_module = __webpack_require__(47909);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./components/Svg/Eye.js

function Eye(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1418 916",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M708.531 676.277c120.483 0 218.154-97.671 218.154-218.154 0-120.483-97.671-218.154-218.154-218.154-120.483 0-218.154 97.671-218.154 218.154 0 120.483 97.671 218.154 218.154 218.154z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M1395.29 397.695C1227.6 195.057 973.767 0 708.516 0 443.214 0 189.318 195.193 21.7404 397.695c-28.9872 35.013-28.9872 85.843 0 120.857 42.131 50.911 130.4556 149.19 248.4226 235.061 297.096 216.277 578.956 216.755 876.707 0 117.97-85.871 206.29-184.15 248.42-235.061 28.9-34.946 29.05-85.729 0-120.857zM708.516 152.708c168.415 0 305.414 137 305.414 305.415 0 168.415-136.999 305.416-305.414 305.416S403.101 626.538 403.101 458.123s137-305.415 305.415-305.415z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Input.js





var Input = function(param) {
    var value = param.value, type = param.type, onFocus = param.onFocus, onBlur = param.onBlur, onChange = param.onChange, onKeyUp = param.onKeyUp, placeholder = param.placeholder, label = param.label, name = param.name, disabled = param.disabled, color = param.color, error = param.error, register = param.register, _classes = param.classes, classes = _classes === void 0 ? [] : _classes, labelAbove = param.labelAbove, autoComplete = param.autoComplete;
    var ref = (0,react.useState)(type || "text"), inputType = ref[0], setInputType = ref[1];
    var ref1 = (0,react.useState)(false), active = ref1[0], setActive = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        var inputValue = (ref = document.getElementById(name)) === null || ref === void 0 ? void 0 : ref.value;
        if (value && value.trim() !== "" || inputValue && inputValue.trim() !== "") setActive(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Input_module_default()).inputWrapper,
            (Input_module_default())["inputWrapper".concat(color)],
            error ? (Input_module_default()).inputWrapperError : null,
            labelAbove ? (Input_module_default()).hasLabelAbove : "", 
        ].join(" "),
        children: [
            labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (Input_module_default()).labelAbove,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: inputType,
                className: [
                    (Input_module_default()).input,
                    active ? (Input_module_default()).inputActive : null, 
                ].concat((0,_to_consumable_array/* default */.Z)(classes), [
                    error ? (Input_module_default()).error : "",
                    labelAbove ? (Input_module_default()).hasLabelAbove : "", 
                ]).join(" "),
                onFocus: function(event) {
                    setActive(true);
                    onFocus ? onFocus(event) : null;
                },
                onBlur: function(event) {
                    event.target.value ? null : setActive(false);
                    onBlur ? onBlur(event) : null;
                },
                onChange: function(event) {
                    setActive(true);
                    onChange ? onChange(event) : null;
                },
                onKeyUp: onKeyUp ? function(param) {
                    var value = param.target.value;
                    return onKeyUp(name, value.trim());
                } : null,
                ref: register,
                placeholder: placeholder,
                defaultValue: value,
                disabled: disabled,
                autoComplete: autoComplete
            }),
            !labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                children: label
            }),
            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Input_module_default()).password,
                onClick: function() {
                    return inputType === "password" ? setInputType("text") : setInputType("password");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye, {})
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Input_module_default()).error,
                children: error.message
            })
        ]
    });
};
/* harmony default export */ var components_Input = (Input);


/***/ }),

/***/ 71642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82844);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function LoginLayout(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().pageLogin),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: [
                "container",
                (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container)
            ].join(" "),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().body),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_1___default().bodyWrapper),
                    style: {
                        width: props.forceWidth ? "100%" : undefined,
                        maxWidth: props.forceWidth ? "none" : undefined
                    },
                    children: props.children
                })
            })
        })
    });
}


/***/ }),

/***/ 11066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42283);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46979);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44217);
/* harmony import */ var components_Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21105);
/* harmony import */ var data_globalConstants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(23208);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64798);
/* harmony import */ var layouts_LoginLayout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71642);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(82844);
/* harmony import */ var styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5056);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2962);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32505);




















function ForgotPassword() {
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)(), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.errors;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_13__/* .authSelector */ .aF), isAuthenticated = ref1.isAuthenticated, company = ref1.company;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visibleMessage = ref2[0], setVisibleMessage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), resetSuccess = ref3[0], setResetSuccess = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isAuthenticated && company) {
            router.replace("/".concat(company));
        }
    }, [
        isAuthenticated,
        company
    ]);
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(data) {
            var res, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api__WEBPACK_IMPORTED_MODULE_6__/* .postReq */ .qu)("/auth/forgot", data)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.status === 201) {
                            setResetSuccess(true);
                            setVisibleMessage(true);
                            return [
                                2,
                                setLoading(false)
                            ];
                        }
                        setVisibleMessage(true);
                        setResetSuccess(false);
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setVisibleMessage(true);
                        setResetSuccess(false);
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_12__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z), {
                titleTemplate: "Forgot Password | %s",
                noindex: true,
                nofollow: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_LoginLayout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                            className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().header),
                            children: [
                                visibleMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: [
                                        (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().errorBox),
                                        resetSuccess ? (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().successBox) : "", 
                                    ].join(" "),
                                    children: resetSuccess ? lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .forgot_password.success */ .jV.Vp : lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .forgot_password.error */ .jV.vU
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().title),
                                    children: lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .forgot_password.title */ .jV.TN
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().copy),
                                    children: lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .forgot_password.body */ .jV.d1
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().inputWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                type: "email",
                                label: "E-mail",
                                name: "email",
                                color: "blue",
                                error: errors["email"],
                                register: register({
                                    required: lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .validation.required */ .Uf.C1,
                                    value: {
                                        pattern: data_globalConstants__WEBPACK_IMPORTED_MODULE_19__/* .EmailRegEx */ ._e,
                                        message: lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .validation.email */ .Uf.Do
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().linksWrapper)
                            ].join(" "),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_modules_Login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().col),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .forgot_password.back */ .jV.op
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            title: lang_en_json__WEBPACK_IMPORTED_MODULE_9__/* .forgot_password.button */ .jV.LI,
                            theme: "primary",
                            type: "submit",
                            loading: loading
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (ForgotPassword);


/***/ }),

/***/ 82844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageLogin":"Login_pageLogin__6XM1O","container":"Login_container__63_yD","body":"Login_body__Zpkpo","bodyWrapper":"Login_bodyWrapper__uxKZh","header":"Login_header__y0gdP","errorBox":"Login_errorBox__8pq4X","successBox":"Login_successBox___DLRj","title":"Login_title__4kHMs","titleSmaller":"Login_titleSmaller__I3UFq","inputWrapper":"Login_inputWrapper__qvNz1","copy":"Login_copy__lv5oh","linksWrapper":"Login_linksWrapper__raBCV","col":"Login_col__krdMt","remember_me":"Login_remember_me__yJ8IV","highlighted":"Login_highlighted__R_Til"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2283,9774,2888,179], function() { return __webpack_exec__(52036); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);